import { getSetup } from './getSetup';

export const fetchAccessToken = async (): Promise<any> => {
	const setup = getSetup();
	const formData = new FormData();
	formData.append(
		'client_id',
		setup.pinpairingActivationResponse.id_token
	);
	formData.append(
		'client_secret',
		setup.pinpairingActivationResponse.refresh_token
	);
	formData.append('grant_type', 'client_credentials');
	const response = await fetch(
		localStorage.getItem('use_qs') === 'true'
			? setup.market.qsUrl  + '/module/delivery/bpca/api/v2/oauth/token'
			: setup.market.urls.delivery + '/module/delivery/bpca/api/v2/oauth/token',
		{
			method: 'POST',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: formData,
		}
	);

	const data = await response.json();
	localStorage.setItem('accesstoken', data.access_token);
	return data.access_token;
};
